import { useTranslation } from "react-i18next";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Col, Row, TreeDataNode, Typography, Space, Card } from "antd";
import { CarryOutOutlined, PlusOutlined } from "@ant-design/icons";

import DetailChapter from "./detail-chapter/DetailChapter";
import {
  TypeCourseStructure,
  TypeChapterList,
  TypeSubjectList,
} from "../../../../../../../types/course-plan-managment/mooc-course-construction-plan";

interface CourseStructureProps {
  dataCourseStructure: TypeChapterList[];
  setDataCourseStructure: (data: TypeChapterList[]) => void;
  typeAssignment: any;
}

const CourseStructure: React.FC<CourseStructureProps> = ({
  dataCourseStructure,
  setDataCourseStructure,
  typeAssignment,
}) => {
  const { t } = useTranslation();
  const [expandAll, setExpandAll] = useState(false);
  const [expandedKeys, setExpandedKeys] = useState<any[]>([]);
  const handleClickExpand = () => {
    setExpandAll(!expandAll);
  };
  useEffect(() => {
    if (expandAll) {
      setExpandedKeys(["0-0", "0-0-0"]);
    } else {
      setExpandedKeys([]);
    }
  }, [expandAll]);
  const onSelect = (selectedKeys: React.Key[], info: any) => {};

  const updateChapterList = (newChapterList: TypeChapterList[]) => {
    setDataCourseStructure(newChapterList);
  };

  const handleAddNewChapter = () => {
    const newChapter: TypeChapterList = {
      structureItemName: t("Chương mới", "Chương mới"),
      structureItemLevel: 1,
      orderNumber: dataCourseStructure ? dataCourseStructure.length + 1 : 1, // Tính toán số thứ tự chương mới
      subjectList: [
        {
          structureItemName: t("Tên bài giảng", "Tên bài giảng"),
          structureItemLevel: 2,
          orderNumber: 1,
          lessonList: [
            {
              structureItemName: t("Tên học liệu", "Tên học liệu"),
              structureItemLevel: 3,
              orderNumber: 1,
            },
          ],
        },
      ],
    };

    // Thêm chương mới vào danh sách chapterList
    const newChapterList = [...(dataCourseStructure || []), newChapter];

    // Gọi hàm cập nhật chapterList mới
    updateChapterList && updateChapterList(newChapterList);
  };

  const [isShowDetailAll, setIsShowDetailAll] = useState<boolean>(true);
  const handleToggleShowDetailAll = () => {
    setIsShowDetailAll(!isShowDetailAll);
  };

  return (
    <Space size="middle" direction="vertical" style={{ width: "100%" }}>
      <Card style={{ marginBottom: "20px", minWidth: "680px" }}>
        <Row justify="space-between" style={{ marginTop: "20px" }}>
          <Col>
            <Row>
              <Typography.Title level={4}>{t("Cấu trúc khóa học", "Cấu trúc khóa học")}</Typography.Title>
            </Row>
            <Row>
              <Typography.Text style={{ color: "GrayText" }}>{t("Xây dựng cấu trúc của khoá học", "Xây dựng cấu trúc của khoá học")}</Typography.Text>
            </Row>
          </Col>
          <Col>
            <Button onClick={handleToggleShowDetailAll}>
              {isShowDetailAll ? t("Thu gọn", "Thu gọn") : t("Hiển thị chi tiết", "Hiển thị chi tiết")}
            </Button>
          </Col>
        </Row>
      </Card>

      <DetailChapter
        // chapterList={chapterList}
        chapterList={dataCourseStructure}
        updateChapterList={updateChapterList}
        isShowDetailAll={isShowDetailAll}
        setIsShowDetailAll={setIsShowDetailAll}
      />

      {/* thêm chương */}
      <>
        <Button
          type="primary"
          onClick={handleAddNewChapter}
          className="w-full button-sticky"
        >
          <PlusOutlined />
          {t("Thêm chương", "Thêm chương")}
        </Button>
      </>
    </Space>
  );
};

export default CourseStructure;
